export default __webpack_public_path__ + "static/media/info.5b2a4dae.svg";